import { Outlet, RouteObject, createBrowserRouter } from "react-router-dom"
import { InternalAdminDashboardScreen } from "~/admin/admin-dashboard-screen"
import {
  RequireSystemAdminSignedIn,
  RequireUserSignedIn,
  RequireUserSignedOut,
} from "~/auth/auth-layouts"
import { LoginLayout } from "~/auth/login-layout"
import { CalendarScreen } from "~/calendar/calendar-screen"
import { OperationsScreen } from "~/calendar/operations-screen"
import {
  calendarPath,
  operationsPath,
  dashboardPath,
  sourceReactionPath,
  newIdeaPath,
  postPath,
  internalAdminDashboardPath,
  loginPath,
  profileEditPath,
  experienceProfilePath,
  profilePath,
  securityPath,
  rootPath,
} from "~/common/paths"
import { DashboardScreen } from "~/dashboard/dashboard-screen"
import { ReactionScreen } from "~/dashboard/reaction-screen"
import { SidebarLayout } from "~/layouts/sidebar-layout"
import { LoginScreen } from "~/login/login-screen"
import { ExperienceProfileScreen } from "~/profile/experience-profile-screen"
import { ProfileEditScreen } from "~/profile/profile-edit-screen"
import { ProfileScreen } from "~/profile/profile-screen"
import { SecurityScreen } from "~/profile/security-screen"
import { ErrorBoundary } from "../ui/error-boundary"
import { RootLayout } from "./root-layout"
import { RootScreen } from "./root-screen"

const systemAdminAuthenticatedRoutes: Array<RouteObject> = [
  {
    path: internalAdminDashboardPath.pattern,
    element: <InternalAdminDashboardScreen />,
  },
]

const authenticatedRoutes: Array<RouteObject> = [
  { path: calendarPath.pattern, element: <CalendarScreen /> },
  { path: operationsPath.pattern, element: <OperationsScreen /> },
  { path: experienceProfilePath.pattern, element: <ExperienceProfileScreen /> },
  { path: securityPath.pattern, element: <SecurityScreen /> },
  { path: sourceReactionPath.pattern, element: <ReactionScreen /> },
  { path: newIdeaPath.pattern, element: <ReactionScreen /> },
  { path: postPath.pattern, element: <ReactionScreen /> },
  {
    path: dashboardPath.pattern,
    element: <DashboardScreen />,
  },
  {
    path: profilePath.pattern,
    element: <ProfileScreen />,
  },
  {
    path: profileEditPath.pattern,
    element: <ProfileEditScreen />,
  },
]

export const router = createBrowserRouter([
  {
    path: "/",
    element: <RootLayout />,
    errorElement: <ErrorBoundary />,
    children: [
      {
        element: <RequireSystemAdminSignedIn />,
        children: [
          {
            element: <SidebarLayout />,
            children: [
              {
                element: <Outlet />,
                children: [...systemAdminAuthenticatedRoutes],
              },
            ],
          },
        ],
      },
      {
        element: <RequireUserSignedIn />,
        children: [
          {
            element: <SidebarLayout />,
            children: [
              {
                element: <Outlet />,
                children: [...authenticatedRoutes],
              },
            ],
          },
        ],
      },
      {
        element: <RequireUserSignedOut />,
        children: [
          {
            element: <LoginLayout />,
            children: [
              {
                path: loginPath.pattern,
                element: <LoginScreen />,
              },
            ],
          },
        ],
      },
      {
        path: rootPath.pattern,
        element: <RootScreen />,
      },
    ],
  },
])
